import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2 } from "lucide-react";

export const TIPOS_INCIDENCIA = ["Faltó mercancía", "Llegó dañado", "Modelo equivocado o cambiado", "Otro"];

// Captura de incidencia del chofer: modelos afectados (sin precios) y nota.
export default function IncidenciaCaptura({ modelos = [], valor, onChange }) {
  const items = valor.items;
  const set = (i, k, v) => onChange({ ...valor, items: items.map((it, j) => (j === i ? { ...it, [k]: v } : it)) });
  const agregar = () => onChange({ ...valor, items: [...items, { tipo: "", modelo: modelos.length === 1 ? modelos[0].modelo : "", atados: "" }] });
  return (
    <div className="space-y-3 rounded-md border border-amber-300 bg-amber-50 p-3" data-testid="incidencia-captura">
      {items.map((it, i) => (
        <div key={i} className="space-y-2 rounded border bg-white p-2" data-testid={`incidencia-item-${i}`}>
          <div className="flex items-center justify-between"><span className="text-xs font-semibold">Problema {i + 1}</span>
            <button type="button" className="text-red-600" onClick={() => onChange({ ...valor, items: items.filter((_, j) => j !== i) })} data-testid={`incidencia-quitar-${i}`}><Trash2 className="h-4 w-4" /></button></div>
          <Select value={it.tipo} onValueChange={(v) => set(i, "tipo", v)}><SelectTrigger data-testid={`incidencia-tipo-${i}`}><SelectValue placeholder="¿Qué pasó?" /></SelectTrigger>
            <SelectContent>{TIPOS_INCIDENCIA.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent></Select>
          <div className="grid grid-cols-[1fr_90px] gap-2">
            <Select value={it.modelo} onValueChange={(v) => set(i, "modelo", v)}><SelectTrigger data-testid={`incidencia-modelo-${i}`}><SelectValue placeholder="Modelo" /></SelectTrigger>
              <SelectContent>{modelos.map((m) => <SelectItem key={m.modelo} value={m.modelo}>{m.modelo}{m.atados ? ` (${m.atados} at.)` : ""}</SelectItem>)}</SelectContent></Select>
            <Input type="number" inputMode="decimal" min="0" step="1" placeholder="Atados" value={it.atados} onChange={(e) => set(i, "atados", e.target.value)} data-testid={`incidencia-atados-${i}`} />
          </div>
        </div>
      ))}
      <Button type="button" variant="outline" className="w-full" onClick={agregar} data-testid="incidencia-agregar"><Plus className="h-4 w-4 mr-1" />{items.length ? "Agregar otro problema" : "Agregar problema"}</Button>
      <div><Label>¿Qué anotó el cliente? (opcional)</Label><Textarea rows={2} value={valor.nota} onChange={(e) => onChange({ ...valor, nota: e.target.value })} data-testid="incidencia-nota" /></div>
    </div>
  );
}

export const incidenciaValida = (v) => v.items.length > 0 && v.items.every((i) => i.tipo && i.modelo && Number(i.atados) > 0);
